import script from "./SfxTableTh.vue?vue&type=script&setup=true&lang=ts"
export * from "./SfxTableTh.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QTh from 'quasar/src/components/table/QTh.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTh,QInput,QIcon,QBtnDropdown,QList,QItem});
